core.directive('pwzValidator', [
        function() {
            var definition = {
                require: 'ngModel',
                link: function(scope, elm, attrs, ctrl) {
                    scope.$watch('identifierType', function () {
                        ctrl.$validate();
                    });

                    ctrl.$validators.pwzValidator = function(modelValue, viewValue) {
                        if (_.isEmpty(modelValue)) {
                            return true;
                        }

                        var pwzRegex = /^[1-9]\d{6}$/;

                        if (pwzRegex.test(modelValue) === false) {
                            return false;
                        }

                        var checkDigit = parseInt(modelValue[0]);
                        var checksum = 0;

                        for (var i = 1; i < 7; i++) {
                            checksum += modelValue[i] * i;
                        }

                        checksum %= 11;

                        return checksum === checkDigit;
                    }
                }
            };

            return definition;
        }]
);